export const initialState = () => ({
	loading: false,
	id: null,
	availableWorkflows: [],
});

export default initialState();
